export default function isInPrivateMode() {
	return location.hash.replace(/#/, "") === 'private';
}


// WEBPACK FOOTER //
// ./src/services/private.js